"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.ErrorTextContainer = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 20px;\n"], ["\n    height: 20px;\n"])));
var Message = styled_components_1.default(react_native_1.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 3px 2px 0px 5px;\n    font-size: 12px;\n    line-height: 20px;\n    font-family: Roboto, sans-serif;\n    color: ", ";\n"], ["\n    padding: 3px 2px 0px 5px;\n    font-size: 12px;\n    line-height: 20px;\n    font-family: Roboto, sans-serif;\n    color: ", ";\n"])), function (props) {
  return props.theme.colors.system.error;
});

var RenderError =
/** @class */
function (_super) {
  __extends(RenderError, _super);

  function RenderError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RenderError.prototype.render = function () {
    return react_1.default.createElement(Message, null, this.props.errorText);
  };

  return RenderError;
}(react_1.default.Component);

exports.RenderError = RenderError;
var templateObject_1, templateObject_2;